import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useMemberAuth } from "./MemberAuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MemberCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const { setMember } = useMemberAuth();
  const [error, setError] = useState(null);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/membros/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const r = await axios.post(`${API}/members/google`, { session_id: sessionId }, { withCredentials: true });
        if (r.data.status === "pending") {
          setPending(true);
          return;
        }
        setMember(r.data.member);
        window.history.replaceState(null, "", "/membros");
        navigate("/membros", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Erro de autenticação");
      }
    })();
  }, [navigate, setMember]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--secondary))] p-6">
      <div className="max-w-md text-center" data-testid="member-callback">
        {error ? (
          <>
            <div className="overline text-[hsl(var(--destructive))]">Erro</div>
            <h1 className="display-heading text-3xl mt-4">{error}</h1>
            <a href="/membros/login" className="btn-outline mt-8 inline-flex">Voltar</a>
          </>
        ) : pending ? (
          <>
            <div className="overline">Pedido enviado</div>
            <h1 className="display-heading text-3xl mt-4 text-[hsl(var(--primary))]">A aguardar aprovação.</h1>
            <p className="mt-6 text-[hsl(var(--muted-foreground))]">A Direção do CIEES vai analisar o seu pedido. Receberá um email assim que estiver aprovado.</p>
            <a href="/" className="btn-outline mt-10 inline-flex">Voltar ao site</a>
          </>
        ) : (
          <>
            <div className="overline">A autenticar</div>
            <h1 className="display-heading text-3xl mt-4">Um momento…</h1>
          </>
        )}
      </div>
    </div>
  );
}
